import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useState } from "react";
import { Stream } from "./Stream";
import { useQuery } from "@tanstack/react-query";
import { useInterval } from "usehooks-ts";
import { StreamApi } from "../../Api/Stream";
import { useConfig } from "../../Config/ConfigContext";
const StreamContext = /*#__PURE__*/ React.createContext(null);
export const StreamProvider = (param)=>{
    let { children  } = param;
    const stream = useStreamQuery();
    return /*#__PURE__*/ _jsx(StreamContext.Provider, {
        value: stream,
        children: children
    });
};
function useStreamQuery() {
    const [timestamp, setTimestamp] = useState(new Date().valueOf() / 1000);
    useInterval(()=>{
        setTimestamp(new Date().valueOf() / 1000);
    }, 5000);
    const { streamPlaylistId  } = useConfig();
    const { data: playlist  } = useQuery([
        "stream playlist"
    ], ()=>new StreamApi().getStreamPlaylist(), {
        placeholderData: []
    });
    return Stream.fromPlaylist(playlist, timestamp, streamPlaylistId);
}
export const useStream = ()=>{
    return useContext(StreamContext);
};
